<p-progressSpinner *ngIf="!showTable" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>
<p-table  *ngIf="showTable" [value]="tableData" scrollable="true" [scrollHeight]="vpHeightToPx(25)" [paginator]="false" fxFlex="1 1 auto" class="liquitics-compact-table" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:50%">Nostro Account</th>
            <th>Balance</th>
            <th>Projected</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td style="width:50%">{{row.account}}</td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.runningBalance | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <span>{{row.runningProjected | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
            </td>
        </tr>
    </ng-template>

    <!-- <p-column [styleClass]="'col-account'" field="account" header="Nostro Account" [sortable]="false" [style]="{'width':'50%','text-align':'center'}"></p-column>
    <p-column [styleClass]="'col-balance'" field="runningBalance" header="Balance" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.runningBalance | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-projected-amount'" field="runningProjected" header="Projected" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.runningProjected | currencyrounding:2:row.currency:false | negativeparentheses}}</span>
        </ng-template>
    </p-column> -->
</p-table>